import React, { useEffect } from 'react';
import { useLocation } from 'react-router';
import usePortalsData from '../../hooks/use-portals-data.hook';
import { PORTAL_TYPE } from '../../types/app.types';
import { useParamsContext } from '../../params/params-context';
import RedirectPageContent from './redirect-page.content';

interface LocationState {
  redirectTo: PORTAL_TYPE;
  redirectedFromClients?: boolean;
}

const RedirectPage: React.FunctionComponent = () => {
  const location = useLocation<LocationState>();
  const portalsData = usePortalsData();
  const { portalType } = useParamsContext();
  const targetPortalData = portalsData(location.state?.redirectTo);
  const currentPortalData = portalType ? portalsData(portalType) : undefined;

  useEffect(() => {
    if (targetPortalData?.rootLink) {
      setTimeout(() => {
        window.location.href = `${targetPortalData?.rootLink}?go_to_form=true${
          location.state.redirectedFromClients
            ? `&redirected_from_clients=${currentPortalData?.rootLink}`
            : ''
        }`;
      }, 3000);
    } else {
      window.location.hash = '/';
    }
  }, [
    currentPortalData?.rootLink,
    location.state?.redirectedFromClients,
    targetPortalData?.rootLink
  ]);

  useEffect(() => {
    window.onpageshow = (event: PageTransitionEvent): void => {
      if (event.persisted) {
        window.location.reload();
      }
    };
  }, []);

  if (!targetPortalData) return null;

  return (
    <RedirectPageContent
      targetPortalData={targetPortalData}
      currentPortalData={currentPortalData}
    />
  );
};

export default RedirectPage;
